import { FETCH_CITY_FAILURE, FETCH_CITY_REQUEST, FETCH_CITY_SUCCESS } from "../actions/types";

const initialState = {
    data: [],
    error: ''
};

export const posCityReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CITY_REQUEST:
            return {
                ...state,
            }
        case FETCH_CITY_SUCCESS:
            return {
                data: action.payload
            }
        case FETCH_CITY_FAILURE:
            return {
                data: [],
                error: action.payload
            }
        default:
            return state;
    }
}